import React from 'react';
interface ButtonProps {
  onClick?: () => void;
  variant?: 'primary' | 'secondary' | 'outline' | 'text';
  size?: 'sm' | 'md' | 'lg';
  fullWidth?: boolean;
  className?: string;
  children: React.ReactNode;
  type?: 'button' | 'submit' | 'reset';
  disabled?: boolean;
}
export const Button = ({
  onClick,
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  className = '',
  children,
  type = 'button',
  disabled = false
}: ButtonProps) => {
  const baseStyles = 'font-medium rounded-lg transition-colors';
  const variantStyles = {
    primary: 'bg-blue-500 hover:bg-blue-600 text-white',
    secondary: 'bg-gray-100 hover:bg-gray-200 text-gray-900',
    outline: 'bg-white border border-gray-300 hover:bg-gray-50 text-gray-700',
    text: 'bg-transparent hover:bg-gray-100 text-blue-500'
  };
  const sizeStyles = {
    sm: 'text-sm py-2 px-3',
    md: 'py-2.5 px-4',
    lg: 'py-3 px-5'
  };
  const widthStyles = fullWidth ? 'w-full' : '';
  const disabledStyles = disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer';
  const buttonStyles = `${baseStyles} ${variantStyles[variant]} ${sizeStyles[size]} ${widthStyles} ${disabledStyles} ${className}`;
  return <button type={type} className={buttonStyles} onClick={onClick} disabled={disabled} data-id="element-1516">
      {children}
    </button>;
};